// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._189ejfq9{border-width:var(--ds-border-width-indicator,3px)}\n._1dqonqa1{border-style:solid}\n._1h6dtmh3{border-color:var(--ds-border-warning,#e56910)}", ""]);
// Exports
module.exports = exports;
